module.exports = __webpack_public_path__ + "static/media/like-button.75cc82e8.svg";